import { useState, ReactNode } from "react"
import { Button, Form, Modal } from 'react-bootstrap'

import LoadingTextSwap from "../LoadingTextSwap"

interface TypeToConfirmButtonProps {
  action: () => Promise<void>,
  title: string,
  message: string,
  buttonText: string,
  isLoading: boolean,
  confirmMessage: string,
  confirmString: string,
  children: ReactNode
}

const TypeToConfirmButton = ({
  action,
  title,
  message,
  buttonText,
  isLoading,
  confirmMessage,
  confirmString,
  children
}: TypeToConfirmButtonProps) => {
  const [ show, setShow ] = useState(false)
  const [ confirmInput, setConfirmInput ] = useState("")

  const handleShow = () => setShow(true)
  const handleClose = () => {
    setShow(false)
    setConfirmInput("")
  }

  const nameConfirmed = confirmInput.toLowerCase() === confirmString.toLowerCase()

  const handleConfirm = async () => {
    await action()
    setConfirmInput("")
    handleClose()
  }

  return (
    <>
      <div onClick={handleShow}>{children}</div>

      <Modal show={show} onHide={handleClose} centered className="p-4">
        <Modal.Header className="border-0 p-0 mb-2">
          <Modal.Title className="fs-5 fw-bold">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 text-muted fs-7 mb-3">{message}</Modal.Body>
        <Modal.Footer className="p-0 pt-3">
          <div className="w-100 fs-7 m-1 fw-semibold">
            {confirmMessage}
          </div>
          <Form.Control
            autoFocus
            type="text"
            className="m-0 mb-3"
            value={confirmInput}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmInput(e.target.value)}
          />
          <div className="m-0 d-flex flex-column flex-sm-row justify-content-end w-100 gap-2">
            <Button disabled={isLoading || !nameConfirmed} className="shadow-sm rounded-3 m-0 fs-7 px-3" variant="dark" onClick={handleConfirm} style={{ minWidth: "100px" }}>
              <LoadingTextSwap isLoading={isLoading}>
                {buttonText}
              </LoadingTextSwap>
            </Button>
            <Button disabled={isLoading} className="bg-white rounded-3 shadow-btn border-light fs-7 px-3" variant="" onClick={handleClose} style={{ minWidth: "100px" }}>
              Cancel
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default TypeToConfirmButton